// extracted by mini-css-extract-plugin
module.exports = {"annal":"Annals_annal__2j-9k","text":"Annals_text__Z551s"};